import React from "react";
import { PRIORIDAD_LABELS, PRIORIDAD_LEVELS, codeOf, labelFor } from "../crmFormat";

// PriorityChip: almost square chip with level bars so Crítica and Alta differ beyond color.
export function PriorityChip({ prioridad }) {
  const level = PRIORIDAD_LEVELS[codeOf(prioridad)] || { tone: "low", bars: 0 };
  return (
    <span className={`crm-rollo__chip crm-rollo__chip--prio crm-rollo__chip--prio-${level.tone}`}>
      <span className="crm-rollo__bars" aria-hidden="true">
        {[1, 2, 3, 4].map((bar) => (
          <i key={bar} className={bar <= level.bars ? "is-on" : undefined} />
        ))}
      </span>
      {labelFor(PRIORIDAD_LABELS, prioridad)}
    </span>
  );
}

// Amber tag (warn tokens) for demora and for a delivered quantity that differs from the requested one.
export function LateTag({ title, children }) {
  return (
    <span className="crm-rollo__late" title={title}>
      {children}
    </span>
  );
}
